import { useState, useEffect } from "react"
import {
    Button,
    IconButton,
    CircularProgress,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Tooltip
} from "@mui/material"
import {
    CameraAlt,
    Close,
    CheckCircle,
    Error,
    WatchLater,
    KeyboardBackspace,
    ExpandMore,
} from "@mui/icons-material"
import { H5, Body2, H4, Body3, H3 } from "../../../themes/typography"

export default function AttendanceScanner({
    startQRScanner = () => { },
    videoRef,
    closeCamera = () => { },
    isCameraOn,
    isCameraInitializing,
    openScanResultModal,
    openModalAndSetVariant = () => { },
    closeModal = () => { },
    scanResult,
    scanResultData,
    onCheckIn = () => { },
    onReject = () => { },
    onViewDetails = () => { },
    onBackTicketDetails = () => { },
    viewDetailsTab,
    detailsLoading,
    viewDetailsData,
    processLoaderType,
    // eventStatus,
    isCountDownActive,
}) {

    // console.log("isCountDownActive in Scanner -> ", isCountDownActive);

    const [openAccordion, setOpenAccordion] = useState(true);

    useEffect(() => {
        if (isCameraOn) {
            setOpenAccordion(false);
        } else {
            setOpenAccordion(true);
        }
    }, [isCameraOn])

    return (
        <div className="event-attendance-home-container">

            <div className="main-attendance-camera-container">

                {!isCameraOn && !isCameraInitializing && (
                    <div className="attendance-camera-icon">
                        <CameraAlt
                            color="tertiary"
                            sx={{ fontSize: '4rem' }}
                        />
                    </div>
                )}

                {isCameraInitializing && (
                    <div className="attendance-camera-icon">
                        <CircularProgress
                            size={64}
                            sx={{
                                color: 'var(--tertiary-color)'
                            }}
                        />
                    </div>
                )}

                <div id="attendance-camera-live-feed">
                    <video
                        ref={videoRef}
                        playsInline
                        muted
                        autoPlay
                        className={`attendance-video-element ${isCameraOn ? 'is-camera-on' : 'is-camera-off'}`}
                    />

                    {isCameraOn && (
                        <div className="scanner-overlay">
                            <div className="scanner-frame">
                                <div className="border-box border-top-left"></div>
                                <div className="border-box border-top-right"></div>
                                <div className="border-box border-bottom-left"></div>
                                <div className="border-box border-bottom-right"></div>
                            </div>
                        </div>
                    )}


                    {openScanResultModal && scanResult === 'validTicket' && (
                        <ValidTicketOverlay
                            ticketName={scanResultData?.ticketName}
                            ticketId={scanResultData?.ticketId}
                            eventName={scanResultData?.eventName}
                            onModalClose={closeModal}
                            onCheckIn={onCheckIn}
                            onViewTicketDetails={onViewDetails}
                            onReject={onReject}
                            detailsLoading={detailsLoading}
                            processLoaderType={processLoaderType}
                        />
                    )}

                    {openScanResultModal && scanResult === 'alreadyCheckedInTicket' && (
                        <AlreadyTicketOverlay
                            ticketName={scanResultData?.ticketName}
                            ticketId={scanResultData?.ticketId}
                            eventName={scanResultData?.eventName}
                            onCheckIn={onCheckIn}
                            onViewTicketDetails={onViewDetails}
                            onModalClose={closeModal}
                            onBack={onBackTicketDetails}
                            isViewDetailActive={viewDetailsTab}
                            onReject={onReject}
                            viewDetailsData={viewDetailsData}
                            detailsLoading={detailsLoading}
                            processLoaderType={processLoaderType}
                        />
                    )}
                    {openScanResultModal && scanResult === 'invalidQrCodeTicket' && (
                        <InvalidQRCodeTicketOverlay
                            onModalClose={closeModal}
                        />
                    )}
                    {openScanResultModal && scanResult === 'wrongEventTicket' && (
                        <WrongEventTicketOverlay
                            onModalClose={closeModal}
                        />
                    )}
                    {openScanResultModal && scanResult === 'enoughPermissionsTicket' && (
                        <EnoughPermissionTicketOverlay
                            onModalClose={closeModal}
                            eventName={scanResultData?.eventName}
                            ticketId={scanResultData?.ticketId}
                            ticketName={scanResultData?.ticketName}
                        />
                    )}
                    {openScanResultModal && scanResult === 'tooEarlyTicket' && (
                        <TooEarlyTicketOverlay
                            onModalClose={closeModal}
                            eventName={scanResultData?.eventName}
                            ticketId={scanResultData?.ticketId}
                            ticketName={scanResultData?.ticketName}
                        />
                    )}
                    {openScanResultModal && scanResult === 'eventExpiredTicket' && (
                        <EventHasEndedTicketOverlay
                            onModalClose={closeModal}
                            eventName={scanResultData?.eventName}
                            ticketId={scanResultData?.ticketId}
                            ticketName={scanResultData?.ticketName}
                        />
                    )}
                </div>

                {!isCameraOn && !isCameraInitializing && (
                    <div className="attendance-camera-start-btn">
                        {isCountDownActive === 'on' && (
                            <Tooltip title="Ticket scanning only available once event is live">
                                <Button
                                    variant="main"
                                    fullWidth
                                    disabled={isCountDownActive === 'on'}
                                    onClick={startQRScanner}
                                >
                                    Start QR Scanner
                                </Button>
                            </Tooltip>
                        )}

                        {isCountDownActive === 'windowEnded' && (
                            <Tooltip title="Ticket Scanning is no longer available">
                                <Button
                                    variant="main"
                                    fullWidth
                                    disabled={isCountDownActive === 'windowEnded'}
                                    onClick={startQRScanner}
                                >
                                    Start QR Scanner
                                </Button>
                            </Tooltip>
                        )}

                        {isCountDownActive === 'off' && (
                            <Button
                                variant="main"
                                fullWidth
                                // disabled={isCountDownActive == 'off'}
                                onClick={startQRScanner}
                            >
                                Start QR Scanner
                            </Button>
                        )}
                    </div>
                )}


                {isCameraInitializing && (
                    <div className="attendance-camera-start-btn">
                        <Button
                            variant="main"
                            fullWidth
                            disabled
                        >
                            Starting Camera...
                        </Button>
                    </div>
                )}

                {isCameraOn && (
                    <div className="attendance-camera-start-btn">
                        <Button
                            variant="main"
                            fullWidth
                            onClick={closeCamera}
                        >
                            Stop Scanning
                        </Button>
                    </div>
                )}
            </div>

            {/* <div className="attendance-taking-person-container"> */}

            <Accordion
                expanded={openAccordion}
                onChange={() => setOpenAccordion(!openAccordion)}
                sx={{
                    alignSelf: 'stretch',
                    fontWeight: 700,
                    background: 'var(--gradient-blue)',
                    color: 'var(--quaternary-color)',
                    borderRadius: '1rem !important',
                    boxShadow: 'none',
                    // textAlign: 'justify',
                    '& .MuiAccordionSummary-root': {
                        height: '56px',
                        minHeight: 'auto !important',
                    },
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        color: 'var(--quaternary-color)'
                    }
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <H5 fontWeight={500}>
                        Instructions
                    </H5>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="manual-search-instructions">
                        <ul>
                            <Body2 fontWeight={400}>
                                <li>
                                    Click "Start QR Scanner" to activate camera
                                </li>
                            </Body2>
                            <Body2 fontWeight={400}>
                                <li>
                                    Point camera at QR code and wait for automatic detection
                                </li>
                            </Body2>
                            <Body2 fontWeight={400}>
                                <li>
                                    Scan results appear as popup overlay on camera view
                                </li>
                            </Body2>
                            <Body2 fontWeight={400}>
                                <li>
                                    For valid tickets, click "Check In Guest" to mark as entered
                                </li>
                            </Body2>
                            <Body2 fontWeight={400}>
                                <li>
                                    Click "Scan Next Ticket" or "Dismiss" to continue scanning
                                </li>
                            </Body2>
                            <Body2 fontWeight={400}>
                                <li>
                                    Real QR scanning now active with jsQR library
                                </li>
                            </Body2>
                            <Body2 fontWeight={400}>
                                <li>
                                    Check browser console (F12) for detailed debug log
                                </li>
                            </Body2>
                        </ul>
                    </div>
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '1rem' }}>
                        {/* 
                        <Button
                            variant="toggleTransparent"
                            onClick={() => openModalAndSetVariant("validTicket")}
                        >
                            Valid Ticket Modal
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            onClick={() => openModalAndSetVariant("alreadyCheckedInTicket")}
                        >
                            Already Checked-In Modal
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            onClick={() => openModalAndSetVariant("tooEarlyTicket")}
                        >
                            Too early Modal
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            onClick={() => openModalAndSetVariant("eventExpiredTicket")}
                        >
                            Event Ended Modal
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            onClick={() => openModalAndSetVariant("enoughPermissionsTicket")}
                        >
                            Enough Permission Modal
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            onClick={() => openModalAndSetVariant("wrongEventTicket")}
                        >
                            Wrong Event Modal
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            onClick={() => openModalAndSetVariant("invalidQrCodeTicket")}
                        >
                            Invalid QR code modal
                        </Button>
                         */}
                    </div>
                </AccordionDetails>
            </Accordion>

            {/* </div> */}
        </div>
    )
}


function ValidTicketOverlay({
    ticketName = "VIP",
    ticketId = "TKT1759467322945",
    onCheckIn = () => { },
    onModalClose = () => { },
    onReject = () => { },
    detailsLoading,
    processLoaderType
}) {

    return (
        <div className="ticket-status-overlay">
            <div
                className={`ticket-status-overlay-wrapper valid-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onModalClose} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="main-ticket-status-details">
                        <div className="ticket-status-container">
                            <div className="ticket-status-icon">
                                <CheckCircle color="success" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="ticket-status-title">
                                <H4 fontWeight={700}>
                                    Valid Ticket
                                </H4>
                            </div>

                            <div className="ticket-status-subtitle">
                                <Body2>
                                    Ticket is valid and ready for check-in. You can proceed to check in the guest.
                                </Body2>
                            </div>

                        </div>

                        <div className="ticket-status-details">

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket ID:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {ticketId}
                                    </Body2>
                                </div>
                            </div>

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket Type:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {ticketName}
                                    </Body2>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="main"
                            fullWidth
                            disabled={(detailsLoading && processLoaderType === 'checkIn')}
                            onClick={onCheckIn}
                        >
                            Check In Guest {detailsLoading && processLoaderType === 'checkIn' && (
                                <CircularProgress
                                    size={20}
                                    sx={{
                                        marginLeft: '0.75rem',
                                        color: 'var(--primary-color)'
                                    }}
                                />
                            )}
                        </Button>

                        <Button
                            variant="reject"
                            disabled={(detailsLoading && processLoaderType === 'reject')}
                            onClick={onReject}
                        >
                            Reject {detailsLoading && processLoaderType === 'reject' && (
                                <CircularProgress
                                    size={20}
                                    sx={{
                                        marginLeft: '0.75rem',
                                        color: 'var(--error-main-color)'
                                    }}
                                />
                            )}
                        </Button>
                    </div>
                </div>

            </div>
        </div>
    );
};

function AlreadyTicketOverlay({
    ticketName = "VIP",
    ticketId = "TKT175946",
    onCheckIn = () => { },
    onModalClose = () => { },
    onViewTicketDetails = () => { },
    onBack = () => { },
    onReject = () => { },
    isViewDetailActive = false,
    viewDetailsData,
    detailsLoading,
    processLoaderType
}) {

    return (
        <div className="ticket-status-overlay">
            <div
                className={`ticket-status-overlay-wrapper warning-ticket-border`}
            >

                <div
                    className="overlay-close-container"
                    style={{ justifyContent: isViewDetailActive ? 'space-between' : 'flex-end' }}
                >
                    {isViewDetailActive && (
                        <IconButton onClick={onBack} sx={{ padding: '0' }}>
                            <KeyboardBackspace />
                        </IconButton>
                    )}

                    {isViewDetailActive && (
                        <H5>
                            Scan History
                        </H5>
                    )}

                    <IconButton onClick={onModalClose} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    {!isViewDetailActive && (
                        <div className="main-ticket-status-details">
                            <div className="ticket-status-container">
                                <div className="ticket-status-icon">
                                    <Error color="secondary" sx={{ fontSize: '3rem' }} />
                                </div>

                                <div className="ticket-status-title">
                                    <H3 fontWeight={700}>
                                        Valid Ticket
                                    </H3>
                                </div>

                            </div>

                            <div className="ticket-subtitle-and-details">
                                <div className="ticket-status-subtitle">
                                    <Body2>
                                        Ticket has been checked in multiple times. Please review ticket details.
                                    </Body2>
                                </div>

                                <div className="ticket-status-details">

                                    <div className="each-ticket-detail">
                                        <div className="each-ticket-detail-label">
                                            <Body2>
                                                Ticket ID:
                                            </Body2>
                                        </div>
                                        <div className="each-ticket-detail-value">
                                            <Body2>
                                                {ticketId}
                                            </Body2>
                                        </div>
                                    </div>

                                    <div className="each-ticket-detail">
                                        <div className="each-ticket-detail-label">
                                            <Body2>
                                                Ticket Type:
                                            </Body2>
                                        </div>
                                        <div className="each-ticket-detail-value">
                                            <Body2>
                                                {ticketName}
                                            </Body2>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    )}

                    {isViewDetailActive && (
                        <div className="main-ticket-status-details">

                            <div className="scan-history-ticket-details-container">

                                <div className="ticket-holder-details">
                                    <div className="align-flex-start each-ticket-detail">
                                        <div className="width-label each-ticket-detail-label">
                                            <Body2 fontWeight={400}>
                                                Holder Name:
                                            </Body2>
                                        </div>
                                        <div className="each-ticket-detail-value">
                                            <Body2 fontWeight={350}>
                                                {viewDetailsData?.attendee_name}
                                            </Body2>
                                        </div>
                                    </div>
                                    <div className="align-flex-start each-ticket-detail">
                                        <div className="width-label each-ticket-detail-label">
                                            <Body2 fontWeight={400}>
                                                Ticket Name:
                                            </Body2>
                                        </div>
                                        <div className="each-ticket-detail-value">
                                            <Body2 fontWeight={350}>
                                                {ticketName}
                                            </Body2>
                                        </div>
                                    </div>
                                </div>

                                <div className="ticket-scanning-history">

                                    <div className="scan-history-list">
                                        {viewDetailsData && viewDetailsData?.attendances?.length === 0 && (
                                            <Body2>No scan history available for this ticket.</Body2>
                                        )}

                                        {viewDetailsData &&
                                            viewDetailsData?.attendances?.length > 0 &&
                                            viewDetailsData?.attendances?.map((attendance, index) => (
                                                <div className="scan-history-item" key={index}>
                                                    <div className="scan-history-info">
                                                        <div className="scan-history-person">
                                                            <Body3 fontWeight={500}>
                                                                {attendance.checked_in_by}
                                                            </Body3>
                                                        </div>
                                                        <div className="scan-history-datetime">
                                                            <Body3>
                                                                {attendance.action_time}
                                                            </Body3>
                                                        </div>
                                                    </div>
                                                    <div className="scan-history-status">
                                                        {attendance.action === 'checked_in' && (
                                                            <Body3 fontWeight={500} color="var(--success-main-color)">
                                                                Checked In
                                                            </Body3>
                                                        )}

                                                        {attendance.action === 'rejected' && (
                                                            <Body3 fontWeight={500} color="var(--error-main-color)">
                                                                Rejected
                                                            </Body3>
                                                        )}
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    )}

                    <div className="ticket-status-actions">
                        {isViewDetailActive && (
                            <Button
                                variant="main"
                                fullWidth
                                disabled={(detailsLoading && processLoaderType === 'checkIn')}
                                onClick={onCheckIn}
                            >
                                Check In Guest {detailsLoading && processLoaderType === 'checkIn' && (
                                    <CircularProgress
                                        size={20}
                                        sx={{
                                            marginLeft: '0.75rem',
                                            color: 'var(--primary-color)'
                                        }}
                                    />
                                )}
                            </Button>
                        )}

                        {!isViewDetailActive && (
                            <Button
                                variant="main"
                                fullWidth
                                disabled={detailsLoading && processLoaderType === 'viewDetails'}
                                onClick={onViewTicketDetails}
                            >
                                View Details {detailsLoading && processLoaderType === 'viewDetails' && (
                                    <CircularProgress
                                        size={20}
                                        sx={{
                                            marginLeft: '0.75rem',
                                            color: 'var(--primary-color)'
                                        }}
                                    />
                                )}
                            </Button>
                        )}

                        <Button
                            variant="reject"
                            disabled={(detailsLoading && processLoaderType === 'reject')}
                            onClick={onReject}
                        >
                            Reject {detailsLoading && processLoaderType === 'reject' && (
                                <CircularProgress
                                    size={20}
                                    sx={{
                                        marginLeft: '0.75rem',
                                        color: 'var(--error-main-color)'
                                    }}
                                />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function InvalidQRCodeTicketOverlay({
    onModalClose = () => { },
}) {

    return (
        <div className="ticket-status-overlay">
            <div
                className={`ticket-status-overlay-wrapper invalid-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onModalClose}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="ticket-status-container">
                        <div className="ticket-status-icon">
                            <Error color="error" sx={{ fontSize: '3rem' }} />
                        </div>

                        <div className="ticket-status-title">
                            <H4 fontWeight={700}>
                                Invalid Ticket
                            </H4>
                        </div>

                        <div className="ticket-status-subtitle">
                            <Body2>
                                The QR code is not valid. Do not allow to check-in.
                            </Body2>
                        </div>

                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onModalClose}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function WrongEventTicketOverlay({
    onModalClose = () => { },
}) {

    return (
        <div className="ticket-status-overlay">
            <div
                className={`ticket-status-overlay-wrapper invalid-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onModalClose}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="ticket-status-container">
                        <div className="ticket-status-icon">
                            <Error color="error" sx={{ fontSize: '3rem' }} />
                        </div>

                        <div className="ticket-status-title">
                            <H4 fontWeight={700}>
                                Invalid Ticket
                            </H4>
                        </div>

                        <div className="ticket-status-subtitle">
                            <Body2>
                                The ticket is not valid for this event. Do not allow to check-in.
                            </Body2>
                        </div>

                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onModalClose}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function EnoughPermissionTicketOverlay({
    ticketName = "VIP",
    ticketId = "TKT1759467322945",
    onModalClose = () => { }
}) {

    return (
        <div className="ticket-status-overlay">
            <div
                className={`ticket-status-overlay-wrapper warning-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onModalClose} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="main-ticket-status-details">
                        <div className="ticket-status-container">
                            <div className="ticket-status-icon">
                                <Error color="secondary" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="ticket-status-title">
                                <H4 fontWeight={700}>
                                    Valid Ticket
                                </H4>
                            </div>

                            <div className="ticket-status-subtitle">
                                <Body2>
                                    You do not have enough permissions to check in this ticket. Please contact event organizer.
                                </Body2>
                            </div>

                        </div>

                        <div className="ticket-status-details">

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket ID:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {ticketId}
                                    </Body2>
                                </div>
                            </div>

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket Type:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {ticketName}
                                    </Body2>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="main"
                            fullWidth
                            disabled
                        >
                            Check In Guest
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onModalClose}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div >
    );
};

function TooEarlyTicketOverlay({
    ticketName = "VIP",
    ticketId = "TKT1759467322945",
    onCheckIn = () => { },
    onModalClose = () => { },
}) {

    return (
        <div className="ticket-status-overlay">
            <div
                className={`ticket-status-overlay-wrapper warning-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onModalClose} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="main-ticket-status-details">
                        <div className="ticket-status-container">
                            <div className="ticket-status-icon">
                                <WatchLater color="secondary" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="ticket-status-title">
                                <H4 fontWeight={700}>
                                    Valid Ticket
                                </H4>
                            </div>

                            <div className="ticket-status-subtitle">
                                <Body2>
                                    The event has not started yet. Please wait until event start to check-in.
                                </Body2>
                            </div>

                        </div>

                        <div className="ticket-status-details">

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket ID:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {ticketId}
                                    </Body2>
                                </div>
                            </div>

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket Type:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {ticketName}
                                    </Body2>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="main"
                            fullWidth
                            disabled
                            onClick={onCheckIn}
                        >
                            Check In Guest
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onModalClose}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div >
    );
};

function EventHasEndedTicketOverlay({
    ticketName = "VIP",
    ticketId = "TKT1759467322945",
    eventName = "Sample Event",
    onCheckIn = () => { },
    onModalClose = () => { },
}) {

    return (
        <div className="ticket-status-overlay">
            <div
                className={`ticket-status-overlay-wrapper warning-ticket-border`}
            >

                <div className="overlay-close-container">
                    <IconButton onClick={onModalClose} sx={{ padding: '0' }}>
                        <Close />
                    </IconButton>
                </div>

                <div className="ticket-details-wrapper">
                    <div className="main-ticket-status-details">
                        <div className="ticket-status-container">
                            <div className="ticket-status-icon">
                                <Error color="secondary" sx={{ fontSize: '3rem' }} />
                            </div>

                            <div className="ticket-status-title">
                                <H4 fontWeight={700}>
                                    Valid Ticket
                                </H4>
                            </div>

                            <div className="ticket-status-subtitle">
                                <Body2>
                                    The event has already ended. Check-in is no longer available.
                                </Body2>
                            </div>

                        </div>

                        <div className="ticket-status-details">

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket ID:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {ticketId}
                                    </Body2>
                                </div>
                            </div>

                            <div className="each-ticket-detail">
                                <div className="each-ticket-detail-label">
                                    <Body2>
                                        Ticket Type:
                                    </Body2>
                                </div>
                                <div className="each-ticket-detail-value">
                                    <Body2>
                                        {ticketName}
                                    </Body2>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="ticket-status-actions">
                        <Button
                            variant="main"
                            fullWidth
                            disabled
                            onClick={onCheckIn}
                        >
                            Check In Guest
                        </Button>

                        <Button
                            variant="toggleTransparent"
                            fullWidth
                            onClick={onModalClose}
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </div >
    );
};